import { FOCUS_GROUP as f, FOCUS_DISABLED as N } from "../constants.js";
import { toArray as c, asArray as i } from "./array.js";
var O = function(r) {
  for (var o = /* @__PURE__ */ new Set(), a = r.length, t = 0; t < a; t += 1)
    for (var e = t + 1; e < a; e += 1) {
      var n = r[t].compareDocumentPosition(r[e]);
      (n & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && o.add(e), (n & Node.DOCUMENT_POSITION_CONTAINS) > 0 && o.add(t);
    }
  return r.filter(function(p, l) {
    return !o.has(l);
  });
}, u = function(r) {
  return r.parentNode ? u(r.parentNode) : r;
}, A = function(r) {
  var o = i(r);
  return o.filter(Boolean).reduce(function(a, t) {
    var e = t.getAttribute(f);
    return a.push.apply(a, e ? O(c(u(t).querySelectorAll("[".concat(f, '="').concat(e, '"]:not([').concat(N, '="disabled"])')))) : [t]), a;
  }, []);
};
export {
  A as getAllAffectedNodes
};
